import { isMsalEnabledForBusiness } from '../isMsalEnabledForBusiness';
import { getQueryStringParameters, stringify } from 'owa-querystring';
import { getWindowData } from 'owa-window-data';

export function handleFallbackScenariosForMSALAnonymous(): void {
    /**
     * Fallback scenarios for when we are rolling out MSAL flight gradually
     * Scenario 1: organizer has MSAL flight enabled and shares it with the recipient who does not have the flight enabled
     * Scenario 2: organizer does not have MSAL flight enabled and shares with a recipient who has the flight disabled
     */
    const queryStringKeyValue = getQueryStringParameters(getWindowData().location);

    // Handle Scenario 1
    if (isMsalEnabledForBusiness() && !hasMSALJsQueryParam(queryStringKeyValue)) {
        queryStringKeyValue.ismsaljsauthenabled = 'true';
        getWindowData().location.search = '?' + stringify(queryStringKeyValue);
    }
    // Handle Scenario 2
    else if (!isMsalEnabledForBusiness() && hasMSALJsQueryParam(queryStringKeyValue)) {
        delete queryStringKeyValue.ismsaljsauthenabled;
        getWindowData().location.search = '?' + stringify(queryStringKeyValue);
    }
}

function hasMSALJsQueryParam(queryStringKV: {}) {
    return Object.keys(queryStringKV).indexOf('ismsaljsauthenabled') >= 0;
}
